import script from "./GroupItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./GroupItem.vue?vue&type=script&lang=ts&setup=true"

import "./GroupItem.vue?vue&type=style&index=0&id=33616582&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33616582"]])

export default __exports__